import {Component, input, signal} from '@angular/core';
import {Tab, TabList, TabPanel, TabPanels, Tabs} from 'primeng/tabs';
import {TranslocoPipe} from '@jsverse/transloco';
import {TabStatusEnum} from '../../../../../shared/tabs/tab-status.model';
import {RfqDocumentUploadContentComponent} from '../tender-rfq-6-documents/rfq-document-upload-content/rfq-document-upload-content.component';
import {TenderRfqPriceListComponent} from '../tender-rfq-5-price-list/tender-rfq-price-list.component';
import {TabStatusDirective} from '../../../../../shared/tabs/tab-status.directive';
import {TabsUnsavedRevealDirective} from '../../../../../shared/tabs/tabs-unsaved-reveal.directive';

@Component({
  selector: 'app-tender-project-response-rfq',
  imports: [
    Tab,
    TabList,
    TabPanel,
    TabPanels,
    Tabs,
    TranslocoPipe,
    RfqDocumentUploadContentComponent,
    TenderRfqPriceListComponent,
    TabStatusDirective,
    TabsUnsavedRevealDirective,
  ],
  templateUrl: './tender-response-rfq.component.html',
})
export class TenderResponseRfqComponent {
  readonly tenderId = input.required<number>();

  protected readonly tabStatus = signal(TabStatusEnum.COMPLETED);
  protected readonly activeTabIndex = signal(0);

  protected onTabChange(index: number | string): void {
    this.activeTabIndex.set(Number(index));
  }
}
